/* global: localStorage */
import {
    call, put, all, takeLatest
} from 'redux-saga/effects';
import { message } from 'antd';
import { fetchApiAuth } from '../utils/api';


import {
    getCastingsSuccess,
    getCastingsFailure
} from './castingActions';

const {
    GET_CASTINGS_REQUEST
} = require('./castingActions').constants;



function* getCastings(action) {
    try {
        const response = yield call(fetchApiAuth, {
            method: 'POST',
            url: 'casting/get-castings',
            body: action.payload
        });

        yield put(getCastingsSuccess(response));
    } catch (e) {
        yield put(getCastingsFailure(e.response ? e.response.data.message : e));
    }
}

/**
 * Watch actions
 */
export default function* userSaga() {
    yield all([
        takeLatest(GET_CASTINGS_REQUEST, getCastings),
    ]);
}
